/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StripeSetupIntentResponse
 */
export interface StripeSetupIntentResponse {
    /**
     * 
     * @type {string}
     * @memberof StripeSetupIntentResponse
     */
    clientSecret: string;
}

/**
 * Check if a given object implements the StripeSetupIntentResponse interface.
 */
export function instanceOfStripeSetupIntentResponse(value: object): value is StripeSetupIntentResponse {
    if (!('clientSecret' in value) || value['clientSecret'] === undefined) return false;
    return true;
}

export function StripeSetupIntentResponseFromJSON(json: any): StripeSetupIntentResponse {
    return StripeSetupIntentResponseFromJSONTyped(json, false);
}

export function StripeSetupIntentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeSetupIntentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientSecret': json['clientSecret'],
    };
}

export function StripeSetupIntentResponseToJSON(json: any): StripeSetupIntentResponse {
    return StripeSetupIntentResponseToJSONTyped(json, false);
}

export function StripeSetupIntentResponseToJSONTyped(value?: StripeSetupIntentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientSecret': value['clientSecret'],
    };
}

